<template>
  <div class="tableBox11">
      <div class="box11Title">培训</div>
      <el-table
        :data="tableData"
        border
        style="width: 98%;margin: auto; height: 243px"
        :header-cell-style="{padding: '9px 3px'}"
        :cell-style="{padding: '8px 3px'}">
        <el-table-column
          prop="courseName"
          label="培训课程">
        </el-table-column>
        <el-table-column
          prop="teacher"
          label="培训讲师">
        </el-table-column>
        <el-table-column
          prop="place"
          label="培训地点">
        </el-table-column>
        <el-table-column
          prop="estStartTime"
          label="开始时间">
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="expireBox">
        <el-pagination
          small
          layout="prev, pager, next" @current-change="handleChange"
          :total="total" :page-size="limit" :current-page="curPage">
        </el-pagination>
      </div>
    </div>
</template>

<script>
import { getPxList } from "@/api/earlyWarning"
export default {
  name: "px",
  data() {
    return {
      tableData: [],
      total: 0,
      limit: 5,
      curPage: 1
    }
  },
  methods: {
    getList() {
      getPxList({ limit: this.limit, curPage: this.curPage }).then(res => {
        // console.log(res)
        this.tableData = res.body.data
        this.total = res.body.cum
      })
    },
    handleChange(val) {
      this.curPage = val
      this.getList()
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style scoped>
  .tableBox11 {
    width: 49%;
    height: 300px;
    border: 1px solid rgb(232,232,232);
    margin-right: 1%;
    margin-bottom: 10px;
  }
  .box11Title {
    padding-left: 8px;
    font-weight: 600
  }
  .expireBox {
    text-align: right;
    margin-top: 3px
  }
</style>